var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('zv-nav-bar',{attrs:{"title":_vm.navtitle}}),_c('div',{staticClass:"news-detail"},[_c('div',{staticClass:"news-title"},[_vm._v(" "+_vm._s(_vm.newsTitle)+" ")]),_c('div',{staticClass:"news-time"},[_vm._v(" "+_vm._s(_vm.newsTime)+" ")]),_c('div',{staticClass:"news-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }